/** localStorage key for the à la carte / Our menu subscription cart. */
export const SUBSCRIPTION_CART_STORAGE_KEY = 'digirasa_subscription_cart';

/** Fired after the subscription cart is cleared on logout so React state can drop. */
export const DIGIRASA_SUBSCRIPTION_CART_CLEARED_EVENT = 'digirasa-subscription-cart-cleared';

export function clearStoredSubscriptionCart() {
  try {
    localStorage.removeItem(SUBSCRIPTION_CART_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** Clear persisted subscription cart and notify SubscriptionCartProvider (used on logout). */
export function clearStoredSubscriptionCartAndNotify() {
  clearStoredSubscriptionCart();
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(DIGIRASA_SUBSCRIPTION_CART_CLEARED_EVENT));
  }
}
